export default __webpack_public_path__ + "static/media/sk.7cfdb214.svg";